import { ErrorMessage, Field, useFormikContext } from "formik";
import React, { useState, useRef } from "react";

import { InputAdornment, CircularProgress } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import MOButtonV2 from "../../../../components/commons/MOButtonV2";
import { useParams } from "react-router";
import mobioApi from "../../../../services";
import { toastMessage } from "../../../../helpers/toastMessage";

const DisplayNameInput = ({ CheckDisplayName, token, onboardingData }) => {
  const { values, setFieldValue } = useFormikContext();
  const [status, setStatus] = useState("idle");
  const [msg, setMsg] = useState("");
  const debounceRef = useRef(null);
  const [saveStatus, setSaveStatus] = useState(false);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();

  const handleChange = (e) => {
    const val = e.target.value.trim();
    setFieldValue("displayName", val);

    // Clear old debounce
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      if (!val) {
        setStatus("idle");
        setMsg("");
        return;
      }

      if (val.length < 3 || val.includes(" ")) {
        setStatus("invalid");
        setMsg("Min 3 chars, no spaces allowed");
        return;
      }

      try {
        setStatus("checking");
        setMsg("Checking availability...");
        await CheckDisplayName(val); // <-- your thunk here
        setStatus("available");
        setMsg("Display name available ✓");
        setSaveStatus(true);
      } catch (e) {
        setStatus("taken");
        setMsg("Display name already taken ✗");
        setSaveStatus(false);
      }
    }, 500);
  };

  const saveDisplayName = async (id, displayName) => {
    try {
      if (!id && !displayName) return;
      setLoading(true);

      const api = mobioApi(token);
      const response = await api.driverDisplayNameSave({
        id,
        displayName,
      });

      if (response?.data?.success) {
        onboardingData.user.displayName = displayName;
      }

      console.log("response", response);
      toastMessage("success", response?.data?.msg);

      setSaveStatus(false);
    } catch (error) {
      console.error("Error fetching onboarding detail:", error);
      toastMessage("error", error?.response?.data.msg);
      setSaveStatus(true);
    } finally {
      setLoading(false);
    }
  };

  const getIcon = () => {
    switch (status) {
      case "checking":
        return <HourglassEmptyIcon color="action" />;
      case "available":
        return <CheckCircleIcon sx={{ color: "green" }} />;
      case "taken":
      case "invalid":
        return <CancelIcon sx={{ color: "red" }} />;
      default:
        return null;
    }
  };

  return (
    <div className="input-field-md-lg">
      <div className="flex align-item-center justify-content-between">
        <div>
          <label>Display Name</label>
        </div>
        {saveStatus && (
          <div>
            <MOButtonV2
              text="SAVE"
              textColor="#ffffff"
              radius={4}
              backgroundColor="#29AEE6"
              onClick={() => {
                saveDisplayName(id, values.displayName);
              }}
              height={22}
              fontSize={10}
              padding={"8px 12px"}
            />
          </div>
        )}
      </div>
      <div style={{ position: "relative" }}>
        <Field
          type="text"
          name="displayName"
          placeholder="Display Name"
          className="type-input-focus"
          onChange={handleChange}
        />
        <InputAdornment
          position="end"
          style={{
            position: "absolute",
            right: 10,
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          {status === "checking" ? <CircularProgress size={18} /> : getIcon()}
        </InputAdornment>
      </div>
      {msg && (
        <p
          className={`font-10 mt-4 ${
            status === "available"
              ? "text-success"
              : status === "taken" || status === "invalid"
              ? "text-danger"
              : "text-muted"
          }`}
        >
          {msg}
        </p>
      )}
      <ErrorMessage
        name="displayName"
        component="p"
        className="text-danger font-10"
      />
    </div>
  );
};

export default DisplayNameInput;
